import getFP from 'lodash/fp/get';
import { createSelector } from 'reselect';

export const getUserGroups = getFP('common.userGroups.data');

export const isVirtualCardTokenized = createSelector(getUserGroups, (userGroups = []) => {
  return userGroups.includes('VIRTUAL_CARD_TOKENIZED');
});

export const isVirtualCardNoUprid = createSelector(getUserGroups, (userGroups = []) => {
  return userGroups.includes('VIRTUAL_CARD_NO_UPRID');
});
